import { pageSelectors } from "./base";

import type { RootState } from "store";

export const selectWorksheetIdByPage = (state: RootState, pageId: string) =>
  pageSelectors.selectById(state, pageId)?.worksheet_id;
